import React from 'react';
import Button from '../../../../Button';
import BankSectionTitle from './BankSectionTitle';
import { connect } from 'react-redux';
import { BANK_OTHER, banks } from './instructionsByBank';
import { getUserBankData } from '../../../../../reducers/banks';
import { getDealInfo } from '../../../../../reducers/DealInfo';
import moment from 'moment';
const BankInstructions = props => {
  const { i18n, bank, next, contract } = props;
  const bankData = getBankData(bank);
  const websiteBtn = bankData.website ? (
    <div className="text-center">
      <Button className="button__inverse" onClick={() => openBankWebsite(bankData.website)} text={i18n('onboarding.bankDetails.bankWebsite')} />
    </div>
  ) : (
    undefined
  );
  const minimumBankAccountLimit = calculateMinimalBankAccountLimit(contract);
  const minBankAuthorizationExpiry = calculateMinimalBankAuthorizationExpiryDate(contract);
  return (
    <div className="bankDetails text-center">
      <BankSectionTitle i18n={i18n} />
      <div className="row justify-content-center">
        <div className="col-10 col-sm-7">
          <ol className="bankDetails__instructions">
            {bankData
              .instructions(minimumBankAccountLimit, minBankAuthorizationExpiry)
              .map((i, key) => <li className="mt-4" key={key} dangerouslySetInnerHTML={{ __html: i }} />)}
          </ol>
          {websiteBtn}
          <Button className={'next_button mb-2'} text={i18n('onboarding.bankDetails.bankDone')} onClick={next} />
        </div>
      </div>
    </div>
  );
};

function getBankData(bank) {
  return banks[bank] || banks[BANK_OTHER];
}

function openBankWebsite(url) {
  window.open(url);
}

function calculateMinimalBankAccountLimit(contract) {
  const { rent, membershipFee, buildingCommittee } = contract.toObject();
  return Math.round((rent + membershipFee + buildingCommittee) * 2 / 10) * 10;
}

function calculateMinimalBankAuthorizationExpiryDate(contract) {
  const startDate = contract.get('startDate');
  const m = moment;
  const expiryDate = m(startDate, 'DD/MM/YYYY')
    .add('2', 'y')
    .add('1', 'm');
  return expiryDate.format('DD/MM/YYYY');
}

const mapStateToProps = state => ({
  i18n: state.lang.i18n,
  bank: getUserBankData(state).get('bankName'),
  contract: getDealInfo(state)
});

export default connect(mapStateToProps)(BankInstructions);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/BankInstructions/BankInstructions.js